import React from 'react';
import Field from './Field';

class FieldQty extends Field {
    constructor(props) {
        super(props);
    }
    format(value) {
        const { allowDecimals, allowNegative } = this.props;

        let newValue = value
            .replace(/[A-Za-z]/g, '')
            // replace the first decimal mark with reserved placeholder
            .replace('.', 'M')

            // strip non numeric letters except minus and "M"
            // this is to ensure prefix has been stripped
            .replace(/[^\dM-]/g, '')

            // replace the leading minus with reserved placeholder
            .replace(/^\-/, 'N')

            // strip the other minus sign (if present)
            .replace(/\-/g, '')

            // replace the minus sign (if present)
            .replace('N', allowNegative ? '-' : '')

            // strip the other dot sign (if present)
            .replace(/\./g, '')

            // replace decimal mark
            .replace('M', '.');

        const lastChar = newValue.charAt(newValue.length - 1);

        // allowDecimals
        if (!allowDecimals) {
            newValue = newValue.replace(/[^0-9-]/g, '');
        }

        // skip validation for now
        if (lastChar == '.' || lastChar == '-' || newValue == '') {
            return newValue;
        }

        return parseInt(newValue);
    }
    changeQty(e, type) {
        const { value, min, max, step, onChange, onControlClick } = this.props;

        // user may clear all number and wants to input their own value
        let newValue = this.format(value.toString());

        if (type === '-') {
            newValue -= step;
        } else if (type === '+') {
            newValue += step;
        }

        if (min && newValue < min) {
            newValue = min;
        } else if (max && newValue > max) {
            newValue = max;
        }

        // SET STATE
        if (onChange) {
            onChange({ target: this.input }, newValue);
        }

        if (onControlClick) {
            onControlClick({ target: this.input }, newValue);
        }
    }
    handleClasses() {
        return super.handleClasses().concat(' field--qty');
    }
    render() {
        const { disabled, min, max, value } = this.props;

        return (
            <div
                className={this.handleClasses()}
                data-label={super.renderAnimatedLabel()}
                ref={(r) => (this.field = r)}
            >
                {super.renderLabel()}
                <span
                    className={`field__control field__control--minus ${
                        value === min ? 'field__control--disabled' : ''
                    }`}
                    onClick={(e) => !disabled && this.changeQty(e, '-')}
                />
                <input
                    className='field__input'
                    ref={(r) => (this.input = r)}
                    {...super.generateProps()}
                    type='number'
                    min={min}
                    max={max}
                />
                <span
                    className={`field__control field__control--plus ${
                        value === max ? 'field__control--disabled' : ''
                    }`}
                    onClick={(e) => !disabled && this.changeQty(e, '+')}
                />
                {super.renderError()}
                {super.renderLoading()}
            </div>
        );
    }
}

export default FieldQty;
